// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "monaco" + "." + "326f267a574d4935ce1b" + ".js";
};